// @ts-nocheck
import { useState } from "react";
import { Menu, MenuItem, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import {
  TableCellWithError,
} from "./SessionPositionEditableSheetTableCell";
// import { StyledTableCell } from "../SessionPositionEditableSheet";
import { getCssVariableHandler } from "../../../../../utils/styles/getCssVariables";

const StyledMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPaper-root": {
    border: "1px solid",
    borderColor: getCssVariableHandler({ variableName: "--primary-pink-hex" }),
    backgroundColor: "#2A2A2A",
    color: theme.palette.common.white,
    borderRadius: "0.25rem",
    padding: "0 !important",
    maxHeight: "40vh",
    overflow: "auto",
  },
  "& .MuiMenu-list": {
    padding: "0 !important",
    maxHeight: "inherit",
    overflowY: "auto",
    borderRadius: "0.25rem",
  },
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  backgroundColor: "#2A2A2A",
  color: theme.palette.common.white,
  fontSize: "0.875rem",
  "&:hover": {
    backgroundColor: "#3A3A3A",
  },
}));

export const SheetDropdown = ({
  options,
  onChange,
  render,
  onContextMenu,
  customError,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (option) => {
    onChange(option.value); // Pass only the value
    handleClose();
  };

  return (
    <TableCellWithError
      customError={customError ?? null}
      onContextMenu={onContextMenu}
    >
      <Box onClick={handleClick} sx={{ cursor: "pointer", width: "100%" }}>
        {render}
      </Box>
      <StyledMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose} // Ensures dropdown closes when clicking outside
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        {options.map((option, index) => (
          <StyledMenuItem key={index} onClick={() => handleSelect(option)}>
            {option.label}
          </StyledMenuItem>
        ))}
      </StyledMenu>
    </TableCellWithError>
  );
};

SheetDropdown.propTypes = {
  value: PropTypes.any,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  render: PropTypes.node.isRequired,
  onContextMenu: PropTypes.func,
  customError: PropTypes.string || undefined,
};